import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import { Table, Image } from "react-bootstrap";
import moment from "moment";
import Row from "react-bootstrap/Row";
// import Image from "react-bootstrap/Image";
// import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
// import { ImageTitleReusableComponent } from "../../../reusableComponents/iconSearchReusableComponent/IconReusableComponent";
import SeatingDashboardLeft from "../seatingDashboard/SeatingDashboardLeft";
import DeletePopup from "../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import {
  SeatingStatus,
  // SeatingStatusTwo,
} from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SeatingStatus";
import TableSizePopup from "../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import Filter from "../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { SeatingDashboardMobile } from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardMobile";
import {
  SeatingDashboardDesktopTableHead,
  SeatingDashboardTableManagement,
} from "../../../reusableComponents/allTableReusable/seatingDashboardTable/SeatingDashboardDesktopTableHead";
import { HistoryDashboardBody } from "../../../reusableComponents/allTableReusable/historyDashboardTable/HistoryDashboardBody";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_all_diner_history,
  get_pending_diner,
} from "../../../../store/actions/dashboardAction/addingAction";
import isEmpty from "../../../../store/validation/is-Empty";
import SocketContext from "../../../../function/SocketContext";
import Media from "react-media";
import { Scan } from "../seatingDashboard/Scan";
import VoiceSearchSeating from "../seatingDashboard/VoiceSearchSeating";
import BasicPagination from "./../../../Pagination/Pagination";
// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import NoContent from "../../../reusableComponents/NoContentComponent";
import SelectFilter from "../../../reusableComponents/selectFilter";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations
const totalRecordsInOnePage = 50;

export class HistoryDashboardScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayGrid: false,
      displayDropDown: false,
      currentPagination: 1,
      allHistoryDinersData: [],
      displayMobileSearch: false,
      displaySearch: false,
      selectedPage: 4,
      open: false,
      orderType: false,
      openPax: false,
      openFilterModel: false,
      showStatus: "All",
      showStatusText: "",
      showPax: "All",
      showPaxText: "",
      orderTypeText: "All",
      filterText: "All",
      filterShowText: "All",
      search: "",
      loader: false,
      orderTypeConfirm: "",
      openScan: false,
      chat: false,
      markSeatAsCompletedCheck: 0,
      scanData: {},
      scanComplete: false,
      showSearch: false,
      sortByDateTimeState: false,
      dateQuery: {},
      dateType: 'THISWEEK'
    };
    this.chatRef = React.createRef();
  }
  sortByDateTime = (e) => {
    this.setState({ sortByDateTimeState: !this.state.sortByDateTimeState });
  };
  HandleChat = (e) => {
    this.setState({ chat: !this.state.chat });
  };

  openChatWindow = (data, actionBy) => (e) => {
    // this.chatRef.current.openNav(data, actionBy);
    this.setState({ chat: !this.state.chat });
    // console.log(this.chatRef.current.openNav());
  };


  onDateChangeHandler = (data, type) => {
    console.log('data', data);
    // this.setState({ dateQuery: data });
    // this.setState({ dateType: type })
    this.props.get_all_diner_history(
      this.props.auth.user.VendorUser._id,
      this.props.auth.user.accessToken,
      data
    );
    // getReportData("", data);
  };

  componentDidMount() {
    this.props.socket.service("diner").on("diner_trigger", (data) => {
      // console.log("@@@@@@@ myevent", data);
      if (
        data.diner_status === "CANCELLED" ||
        data.diner_status === "COMPLETED"
      ) {
        this.props.get_all_diner_history(
          this.props.auth.user.VendorUser._id,
          this.props.auth.user.accessToken,
          this.state.dateQuery
        );
      } else {
        let allDiner = this.state.allHistoryDinersData;
        let objIndex = allDiner.findIndex((obj) => obj._id === data._id);
        allDiner[objIndex] = data;
        this.setState({
          allHistoryDinersData: allDiner,
        });
      }
    });

    //this event will trigger on creating a new diner request
    this.props.socket.service("diner").on("diner_creation", (data) => {
      // console.log("Diner Reservation", data);
    });
    if (this.props.dateQuery?.startDate) {
      this.props.get_all_diner_history(
        this.props.auth.user.VendorUser._id,
        this.props.auth.user.accessToken,
        this.state.dateQuery
      );
    }
    // this.props.get_pending_diner(
    //   this.props.auth.user.VendorUser._id,
    //   this.props.auth.user.accessToken
    // );
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (!isEmpty(this.state.dateQuery) && JSON.stringify(prevState.dateQuery) !== JSON.stringify(this.state.dateQuery)) {
  //     this.props.get_all_diner_history(
  //       this.props.auth.user.VendorUser._id,
  //       this.props.auth.user.accessToken,
  //       this.state.dateQuery
  //     );
  //   }
  // }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps.allHistoryDiners.data);
    if (
      !isEmpty(nextProps.allHistoryDiners.data) !==
      nextState.allHistoryDinersData
    ) {
      let dinerData = nextProps.allHistoryDiners.data;
      for (let i = 0; i < dinerData.length; i++) {
        if (dinerData[i].diner_status !== "SEATED") {
          return {
            allHistoryDinersData: nextProps.allHistoryDiners.data,
            markSeatAsCompletedCheck: 0,
          };
        } else {
          return {
            allHistoryDinersData: nextProps.allHistoryDiners.data,
            markSeatAsCompletedCheck: 1,
          };
        }
      }
    }
    if (!isEmpty(nextProps.auth.loader) !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
  }

  /****************************************
   * @DESC Open Modal
   ***************************************/
  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };
  onOpenOrderTypeModal = () => {
    this.setState({ orderType: true });
  };
  onCloseOrderTypeModal = () => {
    this.setState({ orderType: false });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };
  openModalScan = () => {
    this.setState({ openScan: true });
  };
  closeModalScan = () => {
    this.setState({ openScan: false });
  };

  onOpenFilterModel = () => {
    this.setState({ openFilterModel: !this.state.openFilterModel });
  };

  /****************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  filterButtonHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      filterShowText: type,
    });
  };
  filterSaveClick = (e) => {
    this.setState({
      filterText:
        this.state.filterShowText === "" ? "All" : this.state.filterShowText,
      openFilterModel: false,
    });
  };
  resetFilterClick = (e) => {
    this.setState({
      filterText: "All",
      filterShowText: "All",
      openFilterModel: false,
    });
  };

  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatusText: type,
    });
  };
  selectStatusClick = (e) => {
    this.setState({
      orderTypeText:
        this.state.orderTypeConfirm === ""
          ? "All"
          : this.state.orderTypeConfirm,
      open: false,
    });
  };

  bigButtonShowOrderTypeHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      orderTypeConfirm: type,
      orderType: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    // console.log("hi");
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  searchButton = (e) => {
    e.preventDefault();
    this.setState({
      displaySearch: true,
    });
  };

  searchButtonClose = (e) => {
    e.preventDefault();
    this.setState({ displaySearch: false });
  };

  searchButtonMobile = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: true,
    });
  };

  searchButtonMobileClose = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: false,
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  onVoiceSearchChange = (data) => {
    this.setState({
      search: data,
    });
  };

  onChangePagination = (page) => {
    this.setState({
      currentPagination: page,
    });
  };

  /****************************************
   * @DESC Pending Desktop View Components
   ***************************************/
  renderHistoryCardView = () => {
    const {
      allHistoryDinersData,
      showPax,
      showStatus,
      filterText,
      orderTypeText,
      currentPagination,
    } = this.state;
    let filtereddata = [];
    if (showPax === "All" && orderTypeText === "All" && filterText === "All") {
      filtereddata = allHistoryDinersData && allHistoryDinersData;
    } else if (showPax === "8>") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.adult_count + dinner?.kids_count >= 8
        );
    } else if (showPax === "8") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 7 &&
            dinner?.adult_count + dinner?.kids_count <= 8
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "6") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 5 &&
            dinner?.adult_count + dinner?.kids_count <= 6
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "4") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 3 &&
            dinner?.adult_count + dinner?.kids_count <= 4
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "2") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 0 &&
            dinner?.adult_count + dinner?.kids_count <= 2
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (orderTypeText === "Seated") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "SEATED"
        );
    }
    if (orderTypeText === "Completed") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "COMPLETED"
        );
    }
    if (orderTypeText === "Rejected") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "REJECTED"
        );
    }
    if (orderTypeText === "Cancelled") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "CANCELLED"
        );
    }
    if (filterText === "Walk-in") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (dinner?.service_type === "SEATING" && dinner?.isWalkIn === true) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (filterText === "Waitlist") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.service_type === "SEATING" &&
            dinner?.isWalkIn === false
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (filterText === "Reservation") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.service_type === "RESERVATION"
        );
    }

    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((getall) => {
          if (search.test(getall.user_details.name)) {
            return getall;
          } else if (
            search.test(
              getall.user_details.country_code +
              getall.user_details.mobile_number
            )
          ) {
            return getall;
          } else {
            return false;
          }
        });
    }
    filtereddata = filtereddata.sort((a, b) => {
      if (!this.state.sortByDateTimeState) {
        if (new Date(a.createdAt) < new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) > new Date(b.createdAt)) return -1;
        return 0;
      } else {
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        return 0;
      }
    });
    if (!isEmpty(filtereddata)) {
      return (
        filtereddata &&
        filtereddata.map(
          (data, index) =>
            index >= (currentPagination - 1) * totalRecordsInOnePage &&
            index < currentPagination * totalRecordsInOnePage && (
              <React.Fragment key={index}>
                <HistoryDashboardBody
                  orderType={true}
                  displayCall={true}
                  displaySms={true}
                  displayNotification={true}
                  displayChat={true}
                  displayViewDiner={true}
                  displayEditDiner={false}
                  dinerName={data.user_details.name}
                  dinerInfo={data}
                  actionBy="seating"
                  openChatWindow={this.openChatWindow(data, "seating")}
                  socket={this.props.socket}
                  auth={this.props.auth}
                  // dinerRequestId={`#${data.diner_id}`}
                  // dinerStatus={data.diner_status}
                  // seatingPreference={data.seating_preference[0]}
                  // roomNumber={data.room_number}
                  // tableNumber={data.table_number}
                  // occasion={data.occasion}
                  // // orderType="waitlist"
                  // totalCount={data.adult_count + data.kids_count}
                  // totalAdult={data.adult_count}
                  // totalKids={data.kids_count}
                  // totalHighchair={data.high_chair}
                  // totalHandicapped={data.handicap_chair}
                  // status={data.diner_status}
                  // sendDataDinerProps={data}
                />
              </React.Fragment>
            )
        )
      );
    } else {
      return <NoContent/>;
    }
  };

  /****************************************
   * @DESC Pending Mobile View Components
   ***************************************/
  renderHistoryAccordian = () => {
    const {
      allHistoryDinersData,
      showPax,
      filterText,
      orderTypeText,
      currentPagination,
    } = this.state;
    let filtereddata = [];
    if (showPax === "All" && orderTypeText === "All" && filterText === "All") {
      filtereddata = allHistoryDinersData && allHistoryDinersData;
    } else if (showPax === "8>") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.adult_count + dinner?.kids_count >= 8
        );
    } else if (showPax === "8") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 7 &&
            dinner?.adult_count + dinner?.kids_count <= 8
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "6") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 5 &&
            dinner?.adult_count + dinner?.kids_count <= 6
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "4") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 3 &&
            dinner?.adult_count + dinner?.kids_count <= 4
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    } else if (showPax === "2") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.adult_count + dinner?.kids_count >= 0 &&
            dinner?.adult_count + dinner?.kids_count <= 2
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (orderTypeText === "Seated") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "SEATED"
        );
    }
    if (orderTypeText === "Completed") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "COMPLETED"
        );
    }
    if (orderTypeText === "Rejected") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "REJECTED"
        );
    }
    if (orderTypeText === "Cancelled") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.diner_status === "CANCELLED"
        );
    }
    if (filterText === "Walk-in") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (dinner?.service_type === "SEATING" && dinner?.isWalkIn === true) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (filterText === "Waitlist") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((dinner) => {
          if (
            dinner?.service_type === "SEATING" &&
            dinner?.isWalkIn === false
          ) {
            return dinner;
          } else {
            return false;
          }
        });
    }
    if (filterText === "Reservation") {
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter(
          (dinner) => dinner?.service_type === "RESERVATION"
        );
    }

    if (this.state.search) {
      let search = new RegExp(this.state.search, "i");
      filtereddata =
        allHistoryDinersData &&
        allHistoryDinersData.filter((getall) => {
          if (search.test(getall.user_details.name)) {
            return getall;
          } else if (
            search.test(
              getall.user_details.country_code +
              getall.user_details.mobile_number
            )
          ) {
            return getall;
          } else {
            return false;
          }
        });
    }
    if (!isEmpty(filtereddata)) {
      return (
        filtereddata &&
        filtereddata.map(
          (data, index) =>
            index >= (currentPagination - 1) * totalRecordsInOnePage &&
            index < currentPagination * totalRecordsInOnePage && (
              <React.Fragment key={index}>
                <SeatingDashboardMobile
                  indexKey={index}
                  dinnerIdOriginal={`${data.diner_id}`}
                  dinnerId={`#${data.diner_id}`}
                  dinnerOrderType={"waitlist"}
                  dinnerName={data.user_details.name}
                  totalCount={data.adult_count + data.kids_count}
                  totalAdult={data.adult_count}
                  totalKids={data.kids_count}
                  totalHighchair={data.high_chair}
                  totalHandicapped={data.handicap_chair}
                  displayLocation={false}
                  date={moment(data.createdAt).format("hh:mm A")}
                  time={moment(data.createdAt).format("Do MMM YYYY")}
                  displayButton={data}
                  seatingPreference={data.seating_preference}
                  displayButtonTwo={data}
                  displayCall={true}
                  displaySms={true}
                  displayNotification={true}
                  displayViewDiner={true}
                  tableNo={
                    data.table_number === null ||
                      data.table_number === undefined
                      ? ""
                      : data.table_number
                  }
                  roomNo={data.room_number}
                  specialOcassion={data.occasion}
                  status={data.diner_status}
                  sendDataDinerProps={data}
                  scanData={this.state.scanData}
                  scanComplete={this.state.scanComplete}
                  auth={this.props.auth}
                />
              </React.Fragment>
            )
        )
      );
    } else {
      return <NoContent/>;
    }
  };

  onSuccessScan = (data) => {
    console.log(data);
    this.setState({ scanData: data, scanComplete: true });
  };

  render() {
    try {
      console.log('this.state.dateQuery', this.state.dateQuery)
      const { displayGrid, openScan } = this.state;
      if (this.props.auth.loader === true) {
        return <AmealioLoader />;
      } else {
        return (
          <React.Fragment>
            {/* <ChatWindow ref={this.chatRef} /> */}
            <Media query="(min-width: 992px)">
              <div className="container-fluid seating_dashboard_top_new_header">
                <div className="row">
                  <div className="col-6">
                    <h4>History Dashboard</h4>
                  </div>
                  <div className="col-6 text-right">
                    <NavLink to="/seatingdashboard/adddiner" className="btn">
                      <Image
                        alt="add"
                        title="add"
                        width="40px"
                        src={require("../../../../assets/images/seatingImages/add-button.svg")}
                      />
                      {/* + Add Diner */}
                    </NavLink>
                  </div>
                </div>
              </div>
            </Media>
            <Container fluid className="main-seating-dashboard-body">
              <Media query="(max-width: 992px)">
                <div className="f18-700">History Dashboard</div>
              </Media>
              <Row>
                <SeatingDashboardLeft selectedPage={this.state.selectedPage} />

              </Row>
              <Media query="(min-width: 992px)">
                <div className="w-100">
                  <hr />
                </div>
              </Media>
              <Row>
                <div
                  className="col-12 col-lg-5 col-xl-3 seating-topbar-search"
                  style={{ alignItems: "center" }}
                >
                  <div className="filter-button">
                    <Filter
                      status={this.state.filterText}
                      onOpenModal={this.onOpenFilterModel}
                      onCloseModal={this.onOpenFilterModel}
                      open={this.state.openFilterModel}
                      seatingStatus={this.state.filterShowText}
                      onClickAll={(e) => this.filterButtonHandler(e, "All")}
                      onClickWalkIn={(e) =>
                        this.filterButtonHandler(e, "Walk-in")
                      }
                      onClickWaitlist={(e) =>
                        this.filterButtonHandler(e, "Waitlist")
                      }
                      onClickReservation={(e) =>
                        this.filterButtonHandler(e, "Reservation")
                      }
                      onStatusClick={this.filterSaveClick}
                      resetFilter={this.resetFilterClick}
                    />
                  </div>
                  {/* <Media query="(min-width: 992px)">
                    <div className="filter-button-border-left"></div>
                  </Media> */}

                  <div>
                    <Image
                      onClick={() =>
                        this.setState({ showSearch: !this.state.showSearch })
                      }
                      alt="filter"
                      title="filter"
                      width="80px"
                      src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                    />
                  </div>

                  <Media query="(max-width: 991px)">
                    <Scan
                      openModalScan={this.openModalScan}
                      onCloseModal={this.closeModalScan}
                      open={openScan}
                      sendData={this.props.onboarding}
                      onSuccessScan={this.onSuccessScan}
                    />
                  </Media>
                  <div className="col-5 col-lg-12   mpr-1 d-flex">
                    {this.state.markSeatAsCompletedCheck === 1 ? (
                      <div className="complete_record_image text-center d-flex align-items-center">
                        <DeletePopup
                          display={true}
                          displayPopup="completedRecord"
                          buttonDisplay="completedRecord"
                          buttonText="Complete Record"
                          bigText="Are you sure to Complete All Seated Records ?"
                        />
                        <p className="complete_record_small_text f10-500 pl-2">
                          Mark Seated <br /> as Complete
                        </p>
                      </div>
                    ) : (
                      <div className="text-center d-flex align-items-center">
                        <Image
                          fluid
                          src={require("../../../../assets/images/AuthImages/checked.png")}
                          alt="Checked"
                          title="All Record"
                          className="checked-images"
                          width="25px"
                        />
                        <p className="complete_record_small_text f10-500 pl-2">
                          No Seated <br />
                          Record Found
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div
                  className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-8 pt-3"
                  style={{ alignItems: "center" }}
                >
                  <div className="row">
                    <div className="col-4 col-sm-4 col-md-3 col-lg-3 col-xl-6">
                      <SelectFilter onDateChange={this.onDateChangeHandler} defaultSelected="THISWEEK" />
                    </div>
                    <div
                      className="col-5 col-sm-5 col-md-5 col-lg-6 col-xl-3"
                      style={{ borderRight: "1px solid #E0E0E0" }}
                    >
                      <SeatingStatus
                        status={this.state.orderTypeText}
                        onOpenModal={this.onOpenModal}
                        onCloseModal={this.onCloseModal}
                        open={this.state.open}
                        seatingStatus={this.state.orderTypeConfirm}
                        displayHistory={true}
                        onClickAll={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "All")
                        }
                        onClickNonSeated={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "Not Seated")
                        }
                        onClickSeated={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "Seated")
                        }
                        onClickCancelled={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "Cancelled")
                        }
                        onClickRejected={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "Rejected")
                        }
                        onClickCompleted={(e) =>
                          this.bigButtonShowOrderTypeHandler(e, "Completed")
                        }
                        onStatusClick={this.selectStatusClick}
                        displayNotSeatedButton={true}
                      />
                    </div>
                    <div
                      className="col-3 col-sm-3 col-md-4 col-lg-4 col-xl-3"
                      style={{ borderRight: "1px solid #E0E0E0" }}
                    >
                      <TableSizePopup
                        showPax={this.state.showPax}
                        onOpenModal={this.onOpenModalPax}
                        open={this.state.openPax}
                        onCloseModal={this.onCloseModalPax}
                        table_size={this.state.showPaxText}
                        onClickAll={(e) =>
                          this.bigButtonShowPaxHandler(e, "All")
                        }
                        onClickTwo={(e) => this.bigButtonShowPaxHandler(e, "2")}
                        onClickFour={(e) =>
                          this.bigButtonShowPaxHandler(e, "4")
                        }
                        onClickSix={(e) => this.bigButtonShowPaxHandler(e, "6")}
                        onClickEight={(e) =>
                          this.bigButtonShowPaxHandler(e, "8")
                        }
                        graterThanEight={(e) =>
                          this.bigButtonShowPaxHandler(e, "8>")
                        }
                        selectPaxClick={this.selectPaxClick}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className=" col-12 col-lg-3 col-xl-1 right-side-seating justify-content-end"
                  style={{ alignItems: "center" }}
                >
                  <Media query="(min-width: 992px)">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button
                        type="button"
                        className={
                          displayGrid
                            ? "btn grid-button-group"
                            : "btn grid-button-group grid-button-group-active"
                        }
                        onClick={this.onGridViewOpen}
                      >
                        <img
                          src={require("../../../../assets/images/ActionImages/image/grid.svg")}
                          className="img-fluid"
                          alt="table"
                          title="table"
                        />
                      </button>
                      <button
                        type="button"
                        className={
                          displayGrid
                            ? "btn grid-button-group grid-button-group-active"
                            : "btn grid-button-group"
                        }
                        onClick={this.onGridViewOpen}
                      >
                        <img
                          src={require("../../../../assets/images/ActionImages/image/table.svg")}
                          className="img-fluid"
                          alt="table"
                          title="table"
                        />
                      </button>
                    </div>
                  </Media>
                </div>
              </Row>
              {this.state.showSearch && (
                <div className="mb-3">
                  <ZoomDiv>
                    <>
                      <br />
                      <VoiceSearchSeating
                        onSearchChange={this.onSearchChange}
                        onVoiceSearchChange={(data) =>
                          this.onVoiceSearchChange(data)
                        }
                        search={this.state.search}
                      />
                    </>
                  </ZoomDiv>
                </div>
              )}
              <Media query="(min-width: 992px)">
                <div className="row mt-4">
                  <div
                    className={
                      displayGrid === true ? "col-7 p-0" : "col-12 p-0"
                    }
                  >
                    <div className="col-12">
                      <div className="seating-dashboard-desktop-table">
                        <Table>
                          <SeatingDashboardDesktopTableHead
                            displayGridProps={displayGrid}
                            sortByDateTime={this.sortByDateTime}
                          />
                        </Table>
                      </div>
                    </div>
                    {displayGrid ? null : (
                      <div className="col-12 today-date-dropdown-seating-dashboard">
                        <div>
                          <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                        </div>
                        <div className="seating-dashboard-today-line">
                          <hr className="line" />
                        </div>
                      </div>
                    )}

                    <div className="col-12 seating-dashboard-body-width">
                      {this.props.allHistoryDiners?.data?.length > 0 ? <Table>{this.renderHistoryCardView()}</Table> : <NoContent />}
                    </div>
                  </div>
                  <div
                    className={
                      displayGrid === true
                        ? "col-5 seating-right-side-boxcount p-0"
                        : "d-none"
                    }
                  >
                    <div className="col-12">
                      <div className="seating-dashboard-desktop-table">
                        <Table>
                          <SeatingDashboardTableManagement />
                        </Table>
                      </div>
                    </div>
                  </div>
                </div>
              </Media>
              {/*******************************
               *  @DESC Pending Mobile View
               *******************************/}
              <Media query="(max-width: 991px)">
                <>
                  <div className="row seating-dashboard-table">
                    <div className="col-4 mpr-1">
                      <p className="f12-700 pl-3">Name</p>
                    </div>
                    <div className="col-4 mpl-1 mpr-1">
                      <p className="f12-700">Total PAX</p>
                    </div>
                    <div className="col-4 mpl-1">
                      <p className="f12-700">Timer</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 p-0">
                      <Accordion>{this.renderHistoryAccordian()}</Accordion>
                    </div>
                  </div>
                </>
              </Media>
              <div className="p4v2-menu-pagination">
                {/* <Pagination
                  onChange={this.onChangePagination}
                  current={this.state.currentPagination}
                  defaultPageSize={totalRecordsInOnePage}
                  total={
                    !isEmpty(this.state.allHistoryDinersData)
                      ? this.state.allHistoryDinersData.length
                      : 0
                  }
                  showTitle={false}
                /> */}
                <BasicPagination
                  totalRecords={
                    !isEmpty(this.state.allHistoryDinersData)
                      ? this.state.allHistoryDinersData.length
                      : 0
                  }
                  limit={totalRecordsInOnePage}
                  batch={this.state.currentPagination}
                  onBatchChange={this.onChangePagination}
                />
              </div>
            </Container>
          </React.Fragment>
        );
      }
    } catch (e) {
      console.log(e);
    }
  }
}

HistoryDashboardScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allHistoryDiners: state.allDinerDetails.vendor_all_history_diner,
  allPendingDiners: state.allDinerDetails.vendor_all_pending_diner,
  onboarding: state.onboarding.restaurantDetails,
  auth: state.auth,
  errors: state.errors.errors,
});

const HistoryDashboard = (props) => (
  <SocketContext.Consumer>
    {(socket) => <HistoryDashboardScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_diner_history,
  get_pending_diner,
})(withRouter(HistoryDashboard));
